import React from 'react';
import {classes} from './SkeletonSection.st.css';

interface SkeletonSectionProps {
  children: React.ReactNode;
  dataHook?: string;
}

export const SkeletonSection = ({children, dataHook}: SkeletonSectionProps) => (
  <div data-hook={dataHook} className={classes.section}>
    {children}
  </div>
);
